import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DATE_TIME_FORMAT } from '@models/common.models';
@Component({
  selector: 'app-date-time-display',
  standalone: true,
  imports: [],
  providers: [DatePipe],
  templateUrl: './date-time-display.component.html',
  styleUrl: './date-time-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateTimeDisplayComponent {
  datetime = input.required<Date | string | number | null | undefined>();
  #datePipe: DatePipe = inject(DatePipe);

  formattedDateTime = computed(() => {
    const value = this.datetime();
    if (value) {
      return this.#datePipe.transform(value, DATE_TIME_FORMAT.DATE_TIME_FULL_SLASH) as string;
    } else {
      return '';
    }
  });
}
